import React, { useMemo } from "react";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { Trans } from "@coworker/locales";
import { getActiveTask } from "./QuestionsDetailPage.helper";
import { Question } from "../BackendApiRepository/QuestionResponse";
import { ModalContext } from "@coworker/apprestructured/src/layout/context/ModalContextProvider";
import { ModalType } from "@coworker/apprestructured/src/layout/context/modalType";
import { TaskType } from "@coworker/apprestructured/src/tasks/enums/taskTypes";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import useFlag, { FLAGS } from "@coworker/app/src/hooks/useFlag";
import useSearchParamState from "@coworker/apprestructured/src/shared/hooks/useSearchParamState";
import { useAllTaskTypes } from "@coworker/apprestructured/src/task-management/services/useTaskTypes";
import { TaskTypeNames } from "@coworker/apprestructured/src/task-management/constants/TaskTypeNames";

interface MfaqTaskButtonProps {
  question: Question;
  filters: any; //TODO: Find out if we have type for this
}

const MfaqTaskButtonComponent: React.FC<MfaqTaskButtonProps> = ({
  question,
  filters,
}) => {
  const navigate = useFixaNavigate();
  const { toggleModal } = React.useContext(ModalContext);
  const { hasOngoingTask, taskId } = getActiveTask(question, filters[1]);
  const taskString = hasOngoingTask ? "showTaskString" : "createTaskString";

  const enableMfaqV2 = useFlag(FLAGS.ENABLE_MFAQ_FOLLOWUP_TASK_V2);
  const [, setSearchParams] = useSearchParamState();
  const { data: taskTypes } = useAllTaskTypes();
  const mfaqFollowUpId = useMemo(
    () =>
      taskTypes?.find(({ name }) => name === TaskTypeNames.MFAQ_FOLLOW_UP)?.id,
    [taskTypes]
  );

  const createMFAQTask = () => {
    if (enableMfaqV2 && mfaqFollowUpId) {
      setSearchParams((prev) => {
        prev.set("taskCreator", String(mfaqFollowUpId));
        prev.set(
          "initialValues",
          JSON.stringify({
            details: {
              question_text: question.question_text,
              question_id: question.question_id,
              question_area: filters[1] ?? "",
              upvotes: question.upvotes,
              upvotes_period: filters[0] ?? "",
            },
          })
        );
      });
    } else {
      navigate(`/task/new/mfaq_followup`, {
        state: {
          question: { ...question, question_current_filters: filters },
        },
      });
    }
  };
  const showMFAQTask = () => {
    if (enableMfaqV2) {
      setSearchParams((prev) => {
        prev.set("taskViewer", taskId!);
      });
    } else {
      toggleModal({
        type: ModalType.TaskDetail,
        payload: { taskId: taskId, taskType: TaskType.MFAQ_FOLLOW_UP },
      });
    }
  };
  return (
    <FixaButton
      data-testid="createMFAQTask"
      type="primary"
      text={<Trans>{taskString}</Trans>}
      onClick={taskId ? showMFAQTask : createMFAQTask}
    />
  );
};

export default MfaqTaskButtonComponent;
